import { useContext } from "react"
import { PesquisaSatisfacaoFornecedorContext } from "./PesquisaSatisfacaoFornecedorContext"

export function usePesquisaSatisfacaoFornecedorContext() {
    return useContext(PesquisaSatisfacaoFornecedorContext)
}
